import SpotifyPlayer from "../../../../content/posts/fantastic-beasts-and-where-to-find-them/SpotifyPlayer";
import * as React from 'react';
export default {
  SpotifyPlayer,
  React
};